import { render } from "./EventEdit.vue?vue&type=template&id=46c089ca&ts=true"
import script from "./EventEdit.vue?vue&type=script&lang=ts"
export * from "./EventEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__